export class FUResourceManager {
    token = null
    projectId = ""
    snapshot = null
    avatarsInfo = {}
    controllConfig = ""
    mountRoot = 'GAssets';
    module = null
    usingIDBFS = false;
    version = '1.6.0';
    pendingSyncTasks = [];

    _fileInfo = new Map();   // 记录文件信息  path: { hash, used, latest }

    get itemList() {
        return this.snapshot;
    }

    setModule(module) {
        if(!module.FS) {
            throw 'There is no FileSystem in module';
        }
        this.module = module;
        let resolver;
        let ret = new Promise((res) => resolver = res);
        if(this.preferIDBFS) {
            module.FS.mkdir(this.mountRoot);
            module.FS.mount(module.FS.filesystems.IDBFS, {}, this.mountRoot);
            // 同步缓存
            module.FS.syncfs(true, (err) => {
                if(!err) {
                    this.usingIDBFS = true;
                    // 同步结束 写入文件信息到 ResourceManager
                    this.populateFS();
                } else {
                    console.error(err);
                }
                resolver();
            });
        } else {
            resolver();
        }
        return ret;
    }

    clearHashIinfo() {
        for(let i=0; i<window.localStorage.length; i++) {
            const key = window.localStorage.key(i);
            if(key.startsWith('GAssets')) {
                window.localStorage.setItem(key, '');
            }
        }
    }

    populateFS() {
        const version_key = 'fu_renderkit_version';
        const version = window.localStorage.getItem(version_key);
        if(version !== this.version) {
            this.clearHashIinfo();
            window.localStorage.setItem(version_key, this.version);
        }
        const dfs = (parent, fileInfo) => {
            const childrenPaths = this.module.FS.readdir(parent);
            for(let path of childrenPaths) {
                if(path === '.' || path === '..') {
                    continue;
                } else if(path.endsWith('bundle')) {
                    const fileId = `${parent}/${path}`;
                    const md5 = window.localStorage.getItem(fileId);
                    fileInfo.set(`${parent}/${path}`, {
                        used: false, 
                        latest: false,
                        hash: md5,
                    });
                } else {
                    dfs(`${parent}/${path}`, fileInfo);
                }
            }
        }
        dfs(this.mountRoot, this._fileInfo);
    }

    constructor(param) {
        this.projectId = param.projectid;
        this.appid = param.appId;
        // this.projectVersion = param.projectVersion;
        this.cacheLimit = param.cacheLimit;
        this.preferIDBFS = param.preferIDBFS;
        this.api = param.api;
        this.persistentPaths = new Set();
    }

    /***
     * 项目登录授权
     */
    async initialize() {
        await this.renewToken();
        if (this.token) {
            await this.getAllResourceConfig();
        }
    }
    async auth(requestStr) {
        return this.api.getAuthData({ data: requestStr });
    }
    async renewToken() {
        const now = Date.now();
        let res = await this.api.login();
        if(!res) {
            throw 'token service is down';
        }
        this.token = res.token;
        const expireat = res.expireat;
        setTimeout(() => {
            this.renewToken();
        }, expireat - now);
    }
    async getQuestions() {
        let res;
        try {
            res = await this.api.getTalkSkills({ token: this.token })
        } catch(err) {
            console.error(err);
            res = {
                recommendSkills: [],
            }
        }
        this.questions = res.recommendSkills;
    }

    async getItemListVersion() {
        let projects = await this.api.getProjectV2({
            appid: this.appid,
            token: this.token,
        });
        if (!projects || !projects.list || !projects.list.length) return;
        const project = projects.list.find (i => i.type === "PTAG");
        if (!project) return;
        return project.item_list_version;
    }

    // 获取所有bundle资源
    async getAllResourceConfig() {
        const version = await this.getItemListVersion();

        const requests = [this.api.getItemsSnapshotV2({
            token: this.token,
            version,
        }), this.getCustomResourceConfig(version)];

        const results = await Promise.all(requests);
        
        this.snapshot = results[0];
        this.displayComponents = results[1];

        // this.animations = [];
        
        await this.getControllConfig();
    }

    async getCustomResourceConfig(version) {
        return this.api.getCentreConfigV2({
            token: this.token,
            version,
        });
    }
    async getAvatarConfig(avatarid) {
        if (!avatarid) {
            console.error("请输入avatarId")
            return
        }
        if(!this.avatarsInfo[avatarid]) {
            let avatarConfig = await this.api.getAvatarInfo({
                token: this.token,
                avatarid,
            });
            this.avatarsInfo[avatarid] = avatarConfig;
        }
        
        return this.avatarsInfo[avatarid];
    }
    async getControllConfig() {
        if(!this.controllConfig) {
            const items = this.getGroupInfoFromSnapshot('GAssets/config/controller_config.bundle');
            const { url } = await this.lookupObj(items[0].resource_id);
            this.controllConfig = url;
        }
        return this.controllConfig;
    }

    async saveAvatar(avatarJson) {
        return this.api.saveAvatarInfo({ token: this.token }, avatarJson);
    }

    async genarateAvatar(data) {
        const { taskid } = await this.api.generateAvatar({ token: this.token }, data.image);
        let ret;
        while(!ret) {
            ret = await this.api.downloadAvatarById({token: this.token, taskid});
        }
        return ret;
    }

    async downloadAsset(url, scheduleJob) {
        let file_arraybuffer_promise = this.api.fetchArrayBufferByUrl(url);
        scheduleJob && scheduleJob();
        const file_arraybuffer = await file_arraybuffer_promise;
        return new Uint8Array(file_arraybuffer);
    }

    downloadJson(url) {
        return this.api.fetchTextByUrl(url);
    }

    getGroupInfoFromSnapshot(path) {
        const item = this.snapshot.list.find((v) => v.path === path);
        if (!item) {
            throw `there is no item in snapshot with path: ${path}`;
        }
        let ret = [{
            md5: item.md5,
            path: item.path,
            resource_id: item.resource_id,
        }];
        if(item.config && item.config.children_paths) {
            for(let child of item.config.children_paths) {
                const child_ret = this.getGroupInfoFromSnapshot(child);
                ret = ret.concat(child_ret);
            }
        }
        return ret;
    }

    lookupObj(resource_id) {
        return this.api.getResourceById({ token: this.token, resourceid: resource_id }); // 包含 url 和 hash
    }

    scheduleSyncFS(task) {
        this.pendingSyncTasks.push(task);

        if(this.syncTimeout) {
            clearTimeout(this.syncTimeout);
        }
        this.syncTimeout = setTimeout(() => {
            const doingSyncTasks = this.pendingSyncTasks;
            this.pendingSyncTasks = [];

            const timeout = setTimeout(() => {
                this.usingIDBFS = false;
            }, 1000);
            this.module.FS.syncfs(false, (err) => {
                timeout && clearTimeout(timeout);
                if(err) {
                    this.usingIDBFS = false;
                }
                for(let cd of doingSyncTasks) {
                    cd();
                }
            });
        }, 3000);
        
        return this.fsSync;
    }

    prepareData(path, isPersistent, scheduleJob) {
        if(!this.usingIDBFS) {
            const toRecycleNum = (this._fileInfo.size - this.cacheLimit) + 1;  // 希望总文件数控制在 cacheLimit
            this._recycleRes(toRecycleNum);
            if(isPersistent && !this.persistentPaths.has(path)) {
                this.persistentPaths.add(path);
                this.cacheLimit ++;
            }
        } 

        const items = this.getGroupInfoFromSnapshot(path);

        const requests = [];

        for(let item of items) {
            const itemPath = item.path;
            const itemMD5 = item.md5;
            const itemResourceId = item.resource_id;
           
            if(!this._fileInfo.has(itemPath) || !this._fileInfo.get(itemPath).latest) {
                if(!this._fileInfo.has(itemPath) || this._fileInfo.get(itemPath).hash !== itemMD5) {
                    const p = this.lookupObj(itemResourceId)
                        .then(({url}) => this.downloadAsset(url, scheduleJob))
                        .then((buffer) => {
                            this._writeFs(buffer, itemPath);
                            if(this.usingIDBFS) {
                                this.scheduleSyncFS(() => {
                                    window.localStorage.setItem(itemPath, itemMD5);
                                    console.log('synd done', itemPath)
                                });
                            }
                        });
                        requests.push(p);
                } else {
                    scheduleJob && scheduleJob();
                }

                this._fileInfo.set(itemPath, {
                    used: false,
                    hash: itemMD5,
                    latest: true,
                });
                
            } else {
                scheduleJob && scheduleJob();
            }
        }

        return Promise.all(requests).then(() => path);
    }

    _recycleRes(wantToRecycleNum) {
        let toRecycleNum = Math.min(Math.max(wantToRecycleNum, 0), this._fileInfo.size);
        if(toRecycleNum<=0) {
            return;
        }
        let keys = this._fileInfo.keys();
        for(let key of keys) {
            const item = this._fileInfo.get(key);
            if(!this.persistentPaths.has(key) && item && item.used) {
                this._removeFile(key);
                this._fileInfo.delete(key);
            }
            toRecycleNum--;
            if(toRecycleNum === 0) {
                break;
            }
        }
    }

    async prepareCustomBundle(url, path) {
        // 需要自行进行缓存存取和有效性检查，此处为只进行网络拉取
        const buffer = await this.downloadAsset(url);
        this._writeFs(buffer, path);                
    }

    _removeFile(path) {
        this.module.FS.truncate(path, 0);
        this.module.FS.unlink(path);
    }

    _writeFs(content, path) {
        const index = path.lastIndexOf('/');
        const dir = path.substring(0, index);
        try {
            this.module.FS.stat(dir);
        } catch(s) {
            this.module.FS.mkdirTree(dir);
        }
        this.module.FS.writeFile(path, content, {flags: 'w'});
    }

    markFileUsed(path) {
        const item = this._fileInfo.get(path);
        item.used = true;
        this._fileInfo.set(path, item);
    }

    markFilesUsed(paths) {
        const length = paths.length;

        for(let i=0; i<length; i++) {
            this.markFileUsed(paths[i]);
        }
    }
}
